WiseMetering.Model.SitePackage = WiseMetering.Model.extend({
    urlRoot: '/site_packages',

    getSite: function() {
        return WiseMetering.zones.get(this.get('site_id'));
    },

    getCurrentSensorsDeviation: function() {
        const total = this.getPackage().defaultCurrentSensors();
        return this.get('current_sensors_used') / total || 0;
    },

    getDevicesDeviation: function() {
        const total = this.getPackage().get('devices') + this.get('devices_extra_limit');
        return this.get('devices_used') / total || 0;
    },

    getControlOutputsDeviation: function() {
        const total = this.getPackage().defaultOutputs();
        return this.get('control_outputs_used') / total || 0;
    },

    getPackage: function() {
        return WiseMetering.packages.get(this.get('package_id'));
    },

    getUsed: function(key) {
        const deviation = this[`get${key.split('_').map(x => x.capitalize()).join('')}Deviation`]();

        return {
            value: this.get(`${key}_used`),
            deviation: deviation * 100,
            color: deviation === 1 ? WiseMetering.SemaphorColors.red : WiseMetering.SemaphorColors.green
        };
    },

    getWiseBoxesDeviation: function() {
        const total = this.getPackage().get('wise_boxes') + this.get('wise_boxes_extra_limit');
        return this.get('wise_boxes_used') / total || 0;
    }
});
